/* eslint-disable */
import React from "react";
import { Card, Title, Divider, Text } from "@mantine/core";

export default function ContactCard() {
  return (
    <Card shadow="sm" radius="md" withBorder>
      <Title order={3}>Contact Us</Title>
      <Divider my="md" />
      <Text>
        If you have any questions about this Privacy Policy, please contact us
        at:
      </Text>
      <Text weight={700} mt="sm">
        📧 yawar@nomadstrategies.com
      </Text>
    </Card>
  );
}
